export function returnTextByOrg(organization, textObj) {
  return organization === "southcentralpower"
    ? textObj[organization]
    : organization === "austinutilities"
    ? textObj[organization]
    : organization === "oec"
    ? textObj[organization]
    : organization == undefined
    ? textObj["nisc"]
    : "";
}
